<script setup lang="ts">
import { IStoriesTrack, IBannersTrack, ICity } from '@caks/shared/modules/i'
import { useAccountStore } from '@caks/shared/store/store.account'
import {
  getCategories,
  getCategoriesStopLit,
  getFoodItemInfoStopList,
  getMaxFilledPickup,
  getProfileData,
  getStories,
} from '@caks/shared/api/user.route'
import { FoodItem, Story } from '@caks/shared/types/types.api'
import { IFoodMenu, IFoodItem, IStory } from '@caks/shared/modules/i'
import { ModalCentered, ModalAside, ModalWithoutClose } from '~/components/modal'
import { getFoodItemInfo } from '@caks/shared/api/user.route'
import { IiCart } from '@caks/shared/modules/ii'
import { OrderPickup, OrderNewAddress, OrderPromo } from '~/components/order'
import { Component as ComponentType } from 'vue'
import { ModalElement } from '~/types/components.types'
import { SkeletonChip } from '@caks/uikit/skeleton'
import { ChipTag } from '@caks/uikit/chip'
import { AuthConfirm, AuthPhone } from '~/components/auth'
import ElementPoint from '~/components/element/element.point.vue'

const route = useRoute()
const router = useRouter()
const stories = shallowRef<Array<Story>>([])
const currentFood = shallowRef<Array<FoodItem>>([])
const storyStartIndex = ref(0)
const categoriesElements = ref<NodeListOf<Element>>()
const categoriesChipsElements = ref<NodeListOf<HTMLElement>>()

const store = useAccountStore()

const modal = ref<ModalElement>()
const asideModal = ref<ModalElement>()
const cityModal = ref<ModalElement>()
const phone = ref('')

const cityModalStage = ref('city')

const noPaddingModal = computed(() => {
  const noPaddingContent = ['story', 'new-address']

  //@ts-ignore
  return noPaddingContent.includes(visibleModal.value)
})

type ModalVisible =
  | 'food'
  | 'story'
  | 'order'
  | 'new-address'
  | 'promo'
  | 'auth'
  | 'city'
  | 'authConfirm'

const visibleModal = ref<ModalVisible | null>(null)

watch(
  () => store.asideModalActive,
  (newVal) => {
    console.log('newVal', newVal)
    if (newVal) asideModal.value?.show()
  }
)

watch(
  () => store.cachedFoodItem,
  () => {
    //@ts-ignore
    console.log('fff')
    router.push(`/food/${store.cachedFoodItem.id}`)
    modal.value?.show()

    visibleModal.value = 'food'
  }
)

watch(
  () => store.needChangeLocation,
  () => {
    if (store.needChangeLocation && !store.cart.length) {
      openAddressPicker()
      store.setNeedChangeLocation(false)
    }
  }
)

watch(route, (value) => {
  if (value.name === 'HomeFood') {
    visibleModal.value = 'food'
    modal.value?.show()
  }
})

const openFoodItem = async (id: string) => {
  router.push(`/food/${id}`)
  const { data } = await getFoodItemInfoStopList(id, store.selectedLocation?.iiko_id)
  //@ts-ignore
  store.cachedFoodItem = data[0]
  visibleModal.value = 'food'
  modal.value?.show()
}

const openCityPopup = () => {
  // visibleModal.value = 'city'
  cityModal.value?.show()
}

const openAddAddress = () => {
  visibleModal.value = 'new-address'
  modal.value?.show()
}

const closeModal = (mode?: 'default' | 'cart' | 'city') => {
  if (!mode) mode = 'default'

  switch (mode) {
    case 'default':
      modal.value?.hide()
      break
    case 'cart':
      asideModal.value?.hide()
      break
    case 'city':
      cityModal.value?.hide()
      modal.value?.hide()
      cityModalStage.value = 'city'
      store.locationModalIsOpen = false
      break
  }

  visibleModal.value = null
}

const openStoryModal = (index: number) => {
  storyStartIndex.value = index
  visibleModal.value = 'story'
  //@ts-ignore
  modal.value.show()
}

onMounted(async () => {
  const { data: storiesData } = await getStories()

  stories.value = storiesData

  if (store.selectedLocation && store.orderType === 'delivery') {
    const { data: locationData } = await getMaxFilledPickup(store.cityId)
    //@ts-ignore
    const { data } = await getCategoriesStopLit(locationData.iiko_id)
    //@ts-ignore
    currentFood.value = data
  } else if (store.selectedLocation) {
    const { data } = await getCategoriesStopLit(store.selectedLocation.iiko_id as number)
    //@ts-ignore
    currentFood.value = data
  } else {
    const { data } = await getCategories()
    currentFood.value = data
  }
  if (route.query.state === 'cart') {
    asideModal.value?.show()
  }
  window.addEventListener('scroll', scrollHandler)
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollHandler)
})

const addToCart = () => {
  console.log('addToCart')
  if (store.profile) {
    if (store.cart.length) {
      closeModal()
    } else {
      visibleModal.value = 'order'
    }
  } else {
    visibleModal.value = 'auth'
  }
}

const openAddressPicker = () => {
  visibleModal.value = 'order'
  modal.value?.show()
}

type ModalVisibleContent = {
  [K in ModalVisible]: { component: ComponentType; props: any }
}

const modalVisibleContent = computed((): ModalVisibleContent => {
  return {
    food: {
      component: IFoodItem,
      props: {
        desktop: true,
      },
    },
    story: {
      component: IStory,
      props: {
        stories: stories.value,
        desktop: true,
        activePaginationColor: '#009E50',
        paginationBg: '#EAEAEA',
        startIndex: storyStartIndex.value,
      },
    },
    order: {
      component: OrderPickup,
      props: {
        desktop: true,
      },
    },
    'new-address': {
      component: OrderNewAddress,
      props: {},
    },
    promo: {
      component: OrderPromo,
      props: {},
    },
    city: {
      component: ICity,
      props: {},
    },
    auth: {
      component: AuthPhone,
      props: {
        phone: phone.value,
        onToNextStep: () => {
          store.phone = phone.value.replace(/\D/g, '')
          visibleModal.value = 'authConfirm'
        },
        ['onUpdate:phone']: (value: string) => {
          phone.value = value
        },
      },
    },
    authConfirm: {
      component: AuthConfirm,
      props: {
        onToNextStep: async () => {
          visibleModal.value = 'order'

          const { data: profileData, status } = await getProfileData()
          if (status === 'OK') {
            store.setProfile(profileData)
          }
        },
      },
    },
  }
})

const changeActiveScrollIndex = (index: number) => {
  activeChipIndex.value = index
}

const scrollHandler = (e: Event) => {
  if (categoriesElements.value) {
    const target = (e.target as Document).scrollingElement as HTMLElement
    const scrollY = target.scrollTop

    categoriesElements.value.forEach((current: Element, index: number) => {
      if (current instanceof HTMLElement) {
        const sectionHeight = current.offsetHeight
        const sectionTop = current.offsetTop - 118
        const sectionId = current.getAttribute('id')

        if (sectionId === null) return

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          changeActiveScrollIndex(index)
        }
      }
    })
  }
}

const isMount = ref(false)

onMounted(() => {
  if (route.params.foodId) openFoodItem(route.params.foodId as string)

  isMount.value = true

  if (!store.citySelected) {
    openCityPopup()
  }
})

const onAddAddress = () => {
  visibleModal.value = 'order'
}

const onStoryWatched = (id: number) => {
  if (!store.watchedStoriesIds.includes(id)) {
    store.watchedStoriesIds.push(id)
    localStorage.setItem('wathed-stories', JSON.stringify(store.watchedStoriesIds))
  }
}

const activeChipIndex = ref(0)
const choose = (index: number) => {
  const catList = document.querySelectorAll('.category-item') as NodeListOf<Element>
  catList[index].scrollIntoView({ behavior: 'smooth' })
}

const refetchMenuByLocation = async (id: string) => {
  const { data } = await getCategoriesStopLit(id)
  //@ts-ignore
  currentFood.value = data
}

let timeout: ReturnType<typeof setTimeout>

watch(activeChipIndex, (newValue) => {
  clearTimeout(timeout)

  timeout = setTimeout(() => {
    // if (categoriesChipsElements.value) {
    //   const scrollContaiter = document.querySelector('.sub-header__chips') as HTMLElement
    //   const activeChipElement = categoriesChipsElements.value[newValue]
    //
    //   scrollContaiter.scrollTo({
    //     left: activeChipElement.offsetLeft - 8,
    //     behavior: 'smooth',
    //   })
    // }
  }, 300)
})

watch(
  () => store.selectedLocation,
  () => {
    store.tempCart.forEach((item) => {
      // @ts-ignore
      store.addToCart(item)
    })

    store.tempCart = []
  }
)

watch(
  () => store.locationModalIsOpen,
  async (newValue) => {
    if (newValue) {
      openCityPopup()
    }
  }
)
</script>

<template>
  <main class="home main-container">
    <section class="home__stories">
      <i-stories-track
        desktop
        @open-story="openStoryModal"
        v-if="stories.length"
        :stories="stories"
      />
    </section>

    <section class="home__banners">
      <h2 class="home__section-title">Обратите внимание</h2>
      <i-banners-track v-model:active-index="activeChipIndex" @open-item="openFoodItem" desktop />
    </section>

    <section
      v-for="category in currentFood"
      :id="`${category.id}`"
      ref="categoriesElements"
      class="home__food category-item"
    >
      <h2 class="home__section-title">{{ category.name }}</h2>
      <i-food-menu :foods="category.items" desktop />
    </section>

    <modal-centered @hide="router.push('/')" :no-padding="noPaddingModal" ref="modal">
      <component
        v-if="visibleModal"
        :is="modalVisibleContent[visibleModal].component"
        v-bind="modalVisibleContent[visibleModal].props"
        @change-visible="(value: ModalVisible) => (visibleModal = value)"
        @close="closeModal"
        @add-to-cart="addToCart"
        @add-address="onAddAddress"
        @watch-story="onStoryWatched"
      />
    </modal-centered>

    <modal-without-close ref="cityModal">
      <i-city v-if="cityModalStage === 'city'" desktop @close="cityModalStage = 'point'" />
      <OrderPickup
        v-else-if="cityModalStage === 'point'"
        @change-visible="closeModal('city'), openAddAddress()"
        @close="[refetchMenuByLocation($event), closeModal('city')]"
        @back="cityModalStage = 'city'"
      />
    </modal-without-close>
  </main>
  <teleport v-if="isMount" to=".sub-header__chips">
    <li
      v-if="store.categories.length"
      v-for="(food, index) of store.categories"
      :id="`chip-index-${index}`"
      ref="categoriesChipsElements"
      class="category-chip"
    >
      <chip-tag bigger :active="index === activeChipIndex" @click="choose(index)">
        {{ food.name }}
      </chip-tag>
    </li>
    <div v-else class="chips-skeletons">
      <skeleton-chip v-for="_ in 6" />
    </div>
  </teleport>
</template>

<style scoped lang="scss">
.home {
  &__stories {
    margin-top: 42px;
  }

  &__banners {
    margin-top: 46px;
  }

  &__food {
    margin-top: 46px;
    padding-bottom: 48px;
    scroll-margin-top: 130px;
  }

  &__section-title {
    @include h1-1;
    margin-bottom: 32px;
  }
}

.chips-skeletons {
  display: flex;
  gap: 4px;
}
</style>
